import { useContext } from 'react';

import i18nContext from '../i18n/I18nContext';
import TranslationUtil from '../util/translation';
import EnTexts from '../i18n/eng';

// based off 'i18n/utils'
interface StringsUtils {
    sprintf: (formatString: string, ...args: any[]) => string;
    formatNumber: (number: number, digits: number) => string;
    formatPrice: (priceObject: {
        amount: number;
        currency: string;
    }) => string | null;
    getCurrencySymbol: (currency: string) => string;
    getCurrencyCodeFromAccountingArea: (accountingArea?: {
        currency_code?: string;
    }) => string;
    getCurrencySymbolFromAccountingArea: (accountingArea?: {
        currency_code?: string;
    }) => string;
}

interface DefaultTranslationTools {
    _currentLanguage: string;
    _utils: StringsUtils;
}

type TextType = typeof EnTexts;

function useTranslate<K extends keyof TextType>(
    key: K
): TextType[K] & DefaultTranslationTools {
    const i18n = useContext(i18nContext);

    const language = i18n.i18nTheme.get();
    return TranslationUtil.getTranslationsForContext(key, language);
}

export default useTranslate;
